import {
	IExtremeSet,
	IExtremeSetData,
	ITemplateData,
	ITemplateFormData,
} from '../models';

const slidersExtrenesMapping = (set: IExtremeSet) => {
	return Object.keys(set).reduce((res, k) => {
		if (k === 'id') {
			return {
				...res,
				// @ts-ignore
				[k]: set[k],
			};
		}
		return {
			...res,
			// @ts-ignore
			[k]: { text: set[k] },
		};
	}, {});
};

export function mapTemplateFormData(data: ITemplateData): ITemplateFormData {
	const {
		name,
		questions,
		workStyleSlidersExtremes,
		performanceSlidersExtremes,
		surveyCategories,
		partners,
		npsQuestion,
		quickQuestion,
		longComment,
		isQuick,
	} = data;

	return {
		name,
		questions: questions.map(({ question, id }) => ({ text: question, id })),
		categoryServices: surveyCategories.reduce(
			(res, c) => ({
				...res,
				[c.id]: c.surveyServices?.map(({ id }) => id),
			}),
			{},
		),
		workStyleSlidersExtremes: workStyleSlidersExtremes?.map(
			slidersExtrenesMapping,
		) as IExtremeSetData[],
		performanceSlidersExtremes: performanceSlidersExtremes?.map(
			slidersExtrenesMapping,
		) as IExtremeSetData[],
		partners,
		npsQuestion,
		quickQuestion,
		longComment,
		isQuick,
	};
}
